var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-bottom-view"},[_c('img',{attrs:{"src":require("@/assets/backoff.png"),"alt":""},on:{"click":_vm.goPage}}),_c('img',{attrs:{"src":require("@/assets/forward.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }